import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/AdminVoteValidatorCommentButton';
// FOR ONE GRAPHQL QUERY
export const ADMIN_UPDATE_VALIDATOR_COMMENT = defineAsyncActionTypes(
  `${prefix}/ADMIN_UPDATE_VALIDATOR_COMMENT`
);



// WEBPACK FOOTER //
// ./src/store/graphql/AdminVoteValidatorCommentButton/action-types.js